import { render, staticRenderFns } from "./CrTelegramDestination.vue?vue&type=template&id=07d9a897&"
import script from "./CrTelegramDestination.vue?vue&type=script&lang=js&"
export * from "./CrTelegramDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports